import { jsx } from "react/jsx-runtime";
import { cn } from "../v2/utils.js";
const Loader = ({ size = 's', duration = 1.8, itemClass, className })=>{
    const KLOADER_SIZE = {
        xs: 'tw-h-1.6 tw-w-1.6',
        s: 'tw-h-3.2 tw-w-3.2',
        m: 'tw-h-4.8 tw-w-4.8'
    };
    const KLOADER_ITEM = {
        a: 'tw-loader-item-a',
        b: 'tw-loader-item-b',
        c: 'tw-loader-item-c',
        d: 'tw-loader-item-d',
        e: 'tw-loader-item-e',
        f: 'tw-loader-item-f',
        g: 'tw-loader-item-g',
        h: 'tw-loader-item-h'
    };
    return /*#__PURE__*/ jsx("span", {
        id: "tw-crehana-loader",
        "data-testid": "crehana-loader",
        className: cn(KLOADER_SIZE[size], className),
        children: Object.keys(KLOADER_ITEM).map((loaderId)=>/*#__PURE__*/ jsx("span", {
                id: KLOADER_ITEM[loaderId],
                style: {
                    animationDuration: `${duration}s`
                },
                className: itemClass || 'tw-bg-primary-light-500 dark:tw-bg-neutral-light-100'
            }, KLOADER_ITEM[loaderId]))
    });
};
const Loader_Loader = Loader;
export default Loader_Loader;
